<template>
  <v-row>
    <v-col class="pb-0 pt-0" cols="12" md="12">
      <el-button
        v-if="!onlyView"
        small
        class="mb-3"
        color="primary"
        icon="pridėti"
        title="Įkelti dokumentą"
        @click.native.stop="openNewDocument()"
      />
      <input id="fileUpload" type="file" @change="addFile($event)" hidden />
    </v-col>
    <v-col class="pb-0 pt-0" cols="12" md="12">
      <v-data-table
        class="mb-4 custom-table"
        :headers="headers"
        :items="formData.documents"
        :hide-default-footer="false"
        :header-props="{
          sortByText: $t('Rūšiuoti pagal'),
        }"
      >
        <template #[`item.size`]="{ item }">
          <span>{{getItemSize(item)}}</span>
        </template>
        <!--  -->
        <template #[`item.actions`]="{ item, index }">
          <div style="display: flex;" class="nowrap">
            <el-checkbox
              v-if="isErrorsCorrection"
              class="pt-0 mt-0"
              v-model="item.show_in_statement"
              :disabled="onlyView"
              @click="clickedCheckBox(index, item.show_in_statement)"
              hide-details
            > 
            </el-checkbox>
            <el-table-action
              :item="setDocumentsItem(item)"
              @deleteItem="deleteItem(item)"
              @downloadItem="download(item)"
            />
          </div>
        </template>
      </v-data-table>
    </v-col>
    <!-- modals -->
     <modal-delete
      title="Šalinti dokumentą"
      :text="deleteText"
      v-model="showDelete"
      :loading="loading"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
  </v-row>
  
</template>

<script>
import moment from 'moment'
import math from '@/mixins/math'
import ModalDelete from '@/components/modals/ModalDelete'
import InJournalStatuses from '@/components/constants/inJournalStatus'
import InJournalTypes from '@/components/constants/inJournalTypes'

export default {
  name: 'DocumentsForm',
  mixins: [math],
  components: { ModalDelete },
  props: {
    formData: [Array, Object],
    onlyView: Boolean
  },
  data() {
    return {
      loading: false,
      documentsToDelete: [],
      showDelete: false,
      deleteText: this.$t('Ar tikrai norite pašalinti dokumentą?'),
      modalDeleteItem: null,
    }
  },
  created(){
    this.formData.documentsToDelete = this.documentsToDelete
  },
  computed: {
    isErrorsCorrectionInaccuracies() {
      return this.formData.in_journal_type == InJournalTypes.TARNYBINIS_APIE_NETIKSLUMUS
    },
    isErrorsCorrectionWrongRegistered() {
      return this.formData.in_journal_type == InJournalTypes.TARNYBINIS_APIE_KLAIDINGAI_IREGISTRUOTA
    },
    isErrorsCorrection(){
      return this.isErrorsCorrectionInaccuracies || this.isErrorsCorrectionWrongRegistered
    },
    headers() {
      return [
        {
          text: this.$t('Veiksmai'),
          align: 'center',
          sortable: false,
          value: 'actions',
          width: '3rem',
        },
        {
          text: this.$t('Dokumento pavadinimas'),
          align: 'start',
          value: 'original_filename',
        },
        {
          text: this.$t('Dydis'),
          align: 'start',
          value: 'size',
        },
        {
          text: this.$t('Įkėlimo data'),
          align: 'start',
          value: 'created_at',
        },
      ]
    },
  },
  methods: {
    clickedCheckBox(index, value){
      this.$set(this.formData.documents, index, {
        ...this.formData.documents[index],
        show_in_statement: value
      });
    },
    setDocumentsItem(item){
      if(this.isErrorsCorrection && item.show_in_statement == undefined){
        item.show_in_statement = false
      }
      if(item.id){
        if (this.formData.in_journal_type == InJournalTypes.PROKURA_ISDAVUSIO_JA_DEL_PROKUROS_IREGISTRAVIMO 
            || this.formData.in_journal_type == InJournalTypes.PROKURA_ISDAVUSIO_JA_DEL_PROKUROS_PABAIGOS
            || this.formData.in_journal_type == InJournalTypes.PROKURISTO_DEL_PROKUROS_PABAIGOS
        ) {
          if (this.formData.status == InJournalStatuses.RENGIAMAS) {
            item.canDownload = true
            item.canDelete = true
          } else if (this.formData.status == InJournalStatuses.APMOKETAS) {
            item.canDownload = true 
            item.canDelete = moment(this.formData.payed_date).isBefore(item.created_at)
          } else {
            item.canDownload = true 
            item.canDelete = false
          }
        } else if (this.formData.in_journal_type == InJournalTypes.PRANESIMAS_APIE_PAKEITIMA) {
          item.canDownload = true
          item.canDelete = !item.is_old && this.formData.status == InJournalStatuses.RENGIAMAS
        } else {
          item.canDownload = true
          item.canDelete = !item.is_old
        }
      }
      if(this.onlyView){
        item.canDownload = true
        item.canDelete = false
      }
      return item
    },
     getItemSize(item){
      if(item.id){
        return this.bytesToSize(item.size)
      } else {
        return item.size
      }
      
    },
    deleteItem(item) {
      this.deleteText = this.$t(`Ar tikrai norite pašalinti dokumentą`) + ' ' +  item.original_filename + `?`
      this.modalDeleteItem = Object.assign({}, item)
      this.showDelete = true
    },
    confirmDelete(item) {
      this.showDelete = false
      if(item.id){
        this.documentsToDelete.push(item.id)
        this.formData.documentsToDelete = this.documentsToDelete
      }
      // uploaded
      if(item.id){
        const index = this.formData.documents.findIndex(
        (document) => document.id === item.id
        )
        if (index > -1) {
          this.formData.documents.splice(index, 1)
        }
      } else {
        const subIndex = this.formData.documents.findIndex(
          (document) => document.create_id === item.create_id
        )
        if (subIndex > -1) {
          this.formData.documents.splice(subIndex, 1)
        }
      }
    },
    openNewDocument() {
      document.getElementById('fileUpload').click()
    },
    addFile(e) {
      let file = e.target.files[0]
      if (!file) return

      if (this.isFileTooLarge(file)) {
        this.emitFileTooLargeError(file)
        e.target.value = ''
        return
      }

      let obj = {
        canDelete: true,
        file: file,
        original_filename: file.name,
        size: this.bytesToSize(file.size),
        created_at: moment().format('YYYY-MM-DD HH:mm'),
        create_id: `${file.name}-${Date.now()}`,
      }
      if (
        typeof this.formData.documents === 'undefined' ||
        !Array.isArray(this.formData.documents)
      ) {
        this.$set(this.formData, 'documents', [])
      }
      this.formData.documents.push(obj)
      document.getElementById('fileUpload').value = ""
    },
    download(item) {
      this.loading = true
      this.$axios
        .get(`uploads/${item.id}/download`)
        .then((res) => {
          this.openFile(res.data)
        })
        .catch((err) => {
          const errData = JSON.parse(
            Buffer.from(err.response.data).toString('utf8')
          )
          this.$root.$emit('DATA_ERROR', errData.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    openFile(file) {
      var fileLink = document.createElement('a')
      fileLink.href = file.file
      fileLink.setAttribute(
        'download',
        this.safeFileName(file.original_filename)
      )
      document.body.appendChild(fileLink)
      fileLink.click()
    },
  },
}
</script>

<style>
</style>